module.exports = __webpack_public_path__ + "bin/28cb9d5a7d670ce3e74da6d5d8e42251.png";